<template>
  <div class="disclaimer">
    <div class="disclaimer-title">
      <strong>
        <a href="#" v-on:click="toggleDisclaimer">Disclaimer</a>
      </strong>
    </div>
    <div class="disclaimer-content" v-if="showDisclaimer" v-html="text"></div>
  </div>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      showDisclaimer: false
    };
  },
  methods: {
    toggleDisclaimer() {
      this.showDisclaimer = !this.showDisclaimer;
    }
  }
};
</script>

<style scoped>
  .disclaimer {
    float: right;
    max-width: 50%;
  }
  .disclaimer .disclaimer-title {
    text-align: right;
  }
  .disclaimer .disclaimer-title a {
    color: #73c2af;
    text-decoration: underline;
    display: block;
  }
</style>